import React from 'react';

import { Switch } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { useNavigationListFilters, useNavigationListFiltersDispatch } from '../../context/NavigationListFiltersContext';
import { actions } from '../../ducks/navigationAdminFilterSlice';

export const HideFilteredItemsSwitch = () => {
    const { translateKey } = useTranslate();
    const { filters, hideFilteredItems } = useNavigationListFilters();
    const dispatch = useNavigationListFiltersDispatch();

    const hasFilters = Object.values(filters).some((filtered) => filtered);

    const handleToggle = () => {
        dispatch(actions.hideFilteredItems(!hideFilteredItems));
    };

    return (
        <Switch isDisabled={!hasFilters} isChecked={hideFilteredItems} onChange={handleToggle}>
            {translateKey(GLOBAL.SHOW_ONLY_VISIBLE_ITEMS)}
        </Switch>
    );
};
